import { ExclamationDiamond, X } from "react-bootstrap-icons";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import * as DinamicQueries from "../../api/DinamicsQuery";
import { SelectBox } from "devextreme-react/select-box";
import { TextArea } from "devextreme-react/text-area"; // No eliminar, sin esto no funciona el input textarea aunque no se use la variable
import ScrollView from "devextreme-react/scroll-view";
import React, { useState, useEffect, useMemo } from "react";
import { ArrowRight, ArrowLeft } from "react-bootstrap-icons";
import { Button } from "devextreme-react/button";
import { Toast } from "devextreme-react/toast";
import { CheckBox } from "devextreme-react/check-box";
import "./rutasPlanilla.scss";
import * as ReportsService from "../../api/reports";

import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  Scrolling,
  LoadPanel,
  Selection,
  ColumnChooser,
  Export,
  Editing,
} from "devextreme-react/data-grid";
import { useRef } from "react";

function PlantillaRutas() {
  const [msgPopup, setMsgPopup] = useState(
    "Asignacion de establecimientos a rutas"
  );
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupRuta, setShowPopupRuta] = useState(false);
  const [User, setUser] = useState([]);
  const [Rutas, setRutas] = useState([]);
  const [Establecimientos, setEstablecimientos] = useState([]);
  const [EstablecimientosRutas, setEstablecimientosRutas] = useState([]);
  const [Clientes, setClientes] = useState([]);
  const [Regiones, setRegiones] = useState([]);
  const [UserSelected, setUserSelected] = useState([]);
  const [isPromotor, setisPromotor] = useState(true);
  const [weekButtons, setWeekButtons] = useState(false);
  const [selectedStablisments, setSelectedStablisments] = useState([]);
  const [disabledRuta, setdisabledRuta] = useState(false);
  const initialState = {
    cliente: "",
    nombre_region: "",
    formulario: "",
    establecimientos: [],
    establecimientosFinal: [],
  };
  const [Asignacion, setAsignacion] = useState(initialState);
  const allowedPageSizes = [8, 12, 20];
  const [toastConfig, setToastConfig] = React.useState(
    {
      isVisible: false,
      type: "success",
      message: "Guardado Exitosamente",
      displayTime: 2000,
    },
    []
  );
  const [establecimientosSeleccionados, setEstablecimientosSeleccionados] =
    useState([]);
  const [PlantillaSelectedName, setPlantillaSelectedName] = useState("");
  const [idsEstablecimientoToAssing, setidsEstablecimientoToAssing] = useState(
    []
  );
  const [SelectedIdEstablecimiento, setSelectedIdEstablecimiento] = useState();
  const [PlantillaSelected, setPlantillaSelected] = useState();
  const [showPopupDelete, setShowPopupDelete] = useState(false);
  const [idsEstablecimientoAsiganed, setidsEstablecimientoAsiganed] = useState(
    []
  );
  const [showCrearPlantilla, setShowCrearPlantilla] = useState(false);
  const [showCrearPlantilla1, setShowCrearPlantilla1] = useState(false);
  const [nuevaPlantilla, setNuevaPlantilla] = useState({
    nombre_plantilla: "",
    region: "",
  });
  const [usuarios, setUsuarios] = useState([]);
  const [clientesRegion, setClientesRegion] = useState([]);
  const [clientesFiltrados, setClientesFiltrados] = useState([]);
  const [promotoresFiltrados, setPromotoresFiltrados] = useState([]);
  const [loadingEstablecimientos, setLoadingEstablecimientos] = useState(false);
  // Filtro por región para la grilla principal de rutas
  const [regionFiltro, setRegionFiltro] = useState("");
  const [rutasFiltradas, setRutasFiltradas] = useState([]);

  useEffect(() => {
    DinamicQueries.getData("getrutasPlanilla", "rutasPlanilla/")
      .then((res) => {
        const data = res.data;

        // Actualizar el estado con las rutas obtenidas
        setRutas(data);
      })
      .catch((error) => {
        console.error("Error al obtener rutas:", error);
      });

    ReportsService.getUsuariosPromotores()
      .then((resp) => {
        setUsuarios(resp.data);
      })
      .catch((error) => console.error("Error en getRegion:", error));
    ReportsService.getClients()
      .then((resp) => {
        setClientesRegion(resp.data);
      })
      .catch((error) => console.error("Error en getRegion:", error));

    const userData = JSON.parse(localStorage.getItem("userData"));
    // setClientes(userData.cliente);
    ReportsService.getRegion()
      .then((resp) => {
        setRegiones(resp.data);
      })
      .catch((error) => console.error("Error en getRegion:", error));
  }, []);

  const hidePopup = () => {
    setShowPopup(false);
    setAsignacion(initialState);
    setEstablecimientos([]);
    setLoadingEstablecimientos(false);
    setPlantillaSelected(null); // <-- Limpia la selección
    setMsgPopup("Asignacion de establecimiento rutas");
  };

  const hidePopupRuta = () => {
    setShowPopupRuta(false);
    setAsignacion(initialState);
    setEstablecimientos([]);
    setMsgPopup("Asignacion de establecimientos a rutas");
  };
  const promotoresFiltrados1 = useMemo(() => {
    return usuarios.filter((u) => {
      const regionMatch = u.region?.includes(nuevaPlantilla.region);
      const clienteMatch = u.cliente?.includes(nuevaPlantilla.cliente);
      return regionMatch && clienteMatch;
    });
  }, [usuarios, nuevaPlantilla.region, nuevaPlantilla.cliente]);

  const cellRender = (data) => {
    return (
      <div className="d-flex icons_grid">
        <i
          className="dx-icon-import"
          onClick={() => AsignarData(data.data)}
          title="Administrar establecimientos"
        ></i>
        <i
          className="dx-icon-chevronnext"
          onClick={() => MostrarRuta(data.data)}
          title="Mostrar ruta"
        ></i>
      </div>
    );
  };

  function saveEstablishment(e) {
    const dataEstablecimientos = [...Asignacion.establecimientosFinal];
    idsEstablecimientoToAssing.forEach((eachID) => {
      Establecimientos.forEach((usuarioData) => {
        if (usuarioData.ID_FB === eachID) {
          usuarioData.ID =
            usuarioData.ID == undefined || usuarioData.ID == ""
              ? usuarioData.ID_STORE
              : usuarioData.ID;
          dataEstablecimientos.push(usuarioData);
        }
      });
    });

    let arrayEstablecimiento = [];
    dataEstablecimientos.forEach((eachEstab) => {
      if (arrayEstablecimiento.length > 0) {
        let existe = false;
        arrayEstablecimiento.forEach((x) => {
          if (x.ID === eachEstab.ID) {
            existe = true;
          }
        });
        if (!existe) {
          arrayEstablecimiento.push(eachEstab);
        }
      } else {
        arrayEstablecimiento.push(eachEstab);
      }
    });

    let dataFinal = [];
    arrayEstablecimiento.forEach((x) => {
      let info;
      if (isPromotor) {
        info = {
          ID: x.ID,
          codigo_region:
            x.codigo_region == undefined ? x.ID_REGION_FB : x.codigo_region,
          key: x.key == undefined ? x.ID_FB : x.key,
          nombre_establecimiento:
            x.nombre_establecimiento == undefined
              ? x.NAME
              : x.nombre_establecimiento,
          nombre_region:
            x.nombre_region == undefined ? x.NAME_REGION : x.nombre_region,
          uid_region: x.uid_region == undefined ? x.ID_REGION_FB : x.uid_region,
          dias: x.dias == undefined ? [] : x.dias,
          revisado: x.REVIEWED == undefined ? false : x.REVIEWED,
        };
      } else {
        info = {
          ID: x.ID,
          key: x.key == undefined ? x.ID_FB : x.key,
          nombre_establecimiento:
            x.nombre_establecimiento == undefined
              ? x.NAME
              : x.nombre_establecimiento,
          nombre_region:
            x.nombre_region == undefined ? x.NAME_REGION : x.nombre_region,
          uid_region: x.uid_region == undefined ? x.ID_REGION_FB : x.uid_region,
          dias: x.dias == undefined ? [] : x.dias,
          revisado: x.REVIEWED == undefined ? false : x.REVIEWED,
        };
      }
      dataFinal.push(info);
    });

    DinamicQueries.getDataWithParameters(
      "getAsignarEstablecimientosRutas",
      "rutasPlanilla/",
      { id: PlantillaSelected, establecimientos: dataFinal }
    ).then((data) => {
      if (data.status == 200) {
        setAsignacion(initialState);
        setidsEstablecimientoToAssing([]);
        AsignarData({
          id: PlantillaSelected,
          nombre_plantilla: PlantillaSelectedName,
        });
        getAllUser();

        setEstablecimientosRutas((prevEstablecimientos) => {
          const idsExistentes = new Set(
            prevEstablecimientos.map((item) => item.ID)
          );
          const nuevosEstablecimientos = dataFinal.filter(
            (item) => !idsExistentes.has(item.ID)
          );
          return [...prevEstablecimientos, ...nuevosEstablecimientos];
        });

        setToastConfig({
          ...toastConfig,
          type: "success",
          message: "¡Guardado Exitosamente!",
          isVisible: true,
        });
      } else {
      }
    });
  }

  const getAllUser = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    DinamicQueries.getDataWithParameters("getaUserNewFormat", "usuarios/", {
      uid: userData.uid,
    })
      .then((usuarios) => {
        setUser(usuarios.data);
      })
      .catch((err) => {
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: err.message,
          isVisible: true,
        });
      });
  };

  const AsignarData = (plantilla) => {
    if (!plantilla || !plantilla.id) {
      console.error("La plantilla es inválida o no tiene un ID:", plantilla);
      return;
    }
    setLoadingEstablecimientos(true); // <-- Agrega esto aquí
    setPlantillaSelected(null); // Forzar cambio
    setTimeout(() => {
      setPlantillaSelected(plantilla.id);
      setPlantillaSelectedName(plantilla.nombre_plantilla);

      // Cargar los establecimientos asignados a la plantilla
      DinamicQueries.getDataWithParameters(
        "getrutasPlanillaid",
        "rutasPlanilla/",
        {
          id: plantilla.id,
        }
      )
        .then((resp) => {
          setEstablecimientosRutas(resp.data.dataArray || []);
          setShowPopup(true);
        })
        .catch((error) => {
          console.error("Error al cargar establecimientos asignados:", error);
          setEstablecimientosRutas([]);
          setShowPopup(true);
          setToastConfig({
            ...toastConfig,
            type: "error",
            message: "Error al cargar los establecimientos asignados",
            isVisible: true,
          });
        });
    }, 0);
  };

  const MostrarRuta = (plantilla) => {
    setPlantillaSelected(plantilla.id);
    setPlantillaSelectedName(plantilla.nombre_plantilla);

    DinamicQueries.getDataWithParameters(
      "getrutasPlanillaid",
      "rutasPlanilla/",
      {
        id: plantilla.id,
      }
    ).then((usuario) => {
      DinamicQueries.getDataWithParameters(
        "getEstablecimientoCollection",
        "rutasPlanilla/",
        { id: plantilla.id }
      ).then((EstablecimientosRutas) => {
        let EstablecimientosUsuario = [];
        EstablecimientosRutas.data.data.forEach((establecimientosRuta) => {
          if (establecimientosRuta != undefined) {
            EstablecimientosUsuario.push(establecimientosRuta);
          }
        });

        let dataFinal = [];
        EstablecimientosUsuario.forEach((x) => {
          x.lunes = false;
          x.martes = false;
          x.miercoles = false;
          x.jueves = false;
          x.viernes = false;
          x.sabado = false;
          x.domingo = false;
          if (x.dias != undefined) {
            x.dias.forEach((dia) => {
              switch (dia) {
                case 1:
                  x.lunes = true;
                  break;
                case 2:
                  x.martes = true;
                  break;
                case 3:
                  x.miercoles = true;
                  break;
                case 4:
                  x.jueves = true;
                  break;
                case 5:
                  x.viernes = true;
                  break;
                case 6:
                  x.sabado = true;
                  break;
                case 7:
                  x.domingo = true;
                  break;
                default:
                  break;
              }
            });
          }
          dataFinal.push(x);
        });

        setAsignacion({
          ...Asignacion,
          establecimientos: dataFinal,
          establecimientosFinal: dataFinal,
        });
        setTimeout(() => {
          setdisabledRuta(false);
        }, 1000);
      });
      setShowPopupRuta(true);
    });
  };

  useEffect(() => {
    if (PlantillaSelected && Rutas.length > 0) {
      const plantilla = Rutas.find((r) => r.id === PlantillaSelected);
      if (plantilla?.region) {
        setLoadingEstablecimientos(true);
        setAsignacion((prev) => ({ ...prev, nombre_region: plantilla.region }));

        DinamicQueries.getDataWithParameters("callProcedure", "analytics/", {
          method: "sp_get_storeWithRegion",
          params: { nameRegion: plantilla.region },
        })
          .then((establecimientos) => {
            setEstablecimientos(establecimientos.data || []);
            setLoadingEstablecimientos(false);
          })
          .catch((error) => {
            console.error("Error al buscar establecimientos:", error);
            setEstablecimientos([]);
            setLoadingEstablecimientos(false);
          });
      } else {
        console.warn(
          "No se encontró región para la plantilla:",
          PlantillaSelected
        );
        setEstablecimientos([]);
        setLoadingEstablecimientos(false);
      }
    } else if (PlantillaSelected && Rutas.length === 0) {
    }
  }, [PlantillaSelected, Rutas]);

  // useEffect adicional para manejar la carga cuando se selecciona una plantilla
  useEffect(() => {
    if (PlantillaSelected && !showPopup) {
      // Si se selecciona una plantilla pero el popup no está abierto,
      // limpiar los establecimientos para evitar datos inconsistentes
      setEstablecimientos([]);
      setLoadingEstablecimientos(false);
    }
  }, [PlantillaSelected, showPopup]);

  // Filtrar establecimientos para excluir los que ya están asignados
  const EstablecimientosFiltrados = useMemo(() => {
    if (!EstablecimientosRutas || EstablecimientosRutas.length === 0) {
      return Establecimientos;
    }

    // Crear un Set con los IDs de los establecimientos ya asignados
    const idsAsignados = new Set(
      EstablecimientosRutas.map((est) => est.ID).filter((id) => id != null)
    );

    // Filtrar establecimientos que no estén asignados
    return Establecimientos.filter((est) => {
      // Verificar si el ID_FB o ID_STORE coincide con algún ID asignado
      const idFB = est.ID_FB;
      const idStore = est.ID_STORE;
      const id = est.ID;

      return (
        !idsAsignados.has(idFB) &&
        !idsAsignados.has(idStore) &&
        !idsAsignados.has(id)
      );
    });
  }, [Establecimientos, EstablecimientosRutas]);

  const handleOptionChange = (e) => {
    if (e.fullName === "selectedRowKeys") {
      setidsEstablecimientoToAssing(e.value);
    }
  };

  const openDeletePopup = (uid) => {
    setShowPopupDelete(true);
    setSelectedIdEstablecimiento(uid);
  };

  const hideDeletePopup = () => {
    setShowPopupDelete(false);
  };

  const cellRenderAsignar = (data) => {
    return (
      <div className="d-flex icons_grid">
        <i
          className="dx-icon-trash"
          onClick={() => openDeletePopup(data.data.ID)}
        ></i>
      </div>
    );
  };

  const checkedLabel = { "aria-label": "Checked" };
  const cellRendeRuta = (data) => {
    return (
      <div
        className="d-flex icons_grid"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <CheckBox
          defaultValue={data.value}
          elementAttr={checkedLabel}
          onValueChanged={(e) => changeDays(e, data)}
        />
      </div>
    );
  };

  const changeDays = (e, data) => {
    let dataFinal = [...Asignacion.establecimientosFinal];

    let infoFinal = [];
    dataFinal.forEach((x) => {
      if (x.key == data.data.key) {
        switch (data.columnIndex) {
          case 3:
            x.lunes = e.value;
            break;
          case 4:
            x.martes = e.value;
            break;
          case 5:
            x.miercoles = e.value;
            break;
          case 6:
            x.jueves = e.value;
            break;
          case 7:
            x.viernes = e.value;
            break;
          case 8:
            x.sabado = e.value;
            break;
          case 9:
            x.domingo = e.value;
            break;
          default:
            break;
        }
      }
      infoFinal.push(x);
    });

    setAsignacion({
      ...Asignacion,
      establecimientos: infoFinal,
      establecimientosFinal: infoFinal,
    });
  };

  const deleteEstablecimientos = () => {
    const paramsToSend = {
      id: PlantillaSelected,
      idEstablecimiento: SelectedIdEstablecimiento,
    };
    console.log(
      "🚀 Eliminando establecimiento - Parámetros enviados:",
      paramsToSend
    );

    DinamicQueries.getDataWithParameters(
      "getDeleteAsignacionEstablecimientos",
      "rutasPlanilla/",
      paramsToSend
    )
      .then((data) => {
        console.log("🚀 Respuesta del servidor:", data);
        console.log("🚀 Status de la respuesta:", data.status);
        if (data.status === 200) {
          setAsignacion(initialState);
          hideDeletePopup();
          AsignarData({
            id: PlantillaSelected,
            nombre_plantilla: PlantillaSelectedName,
          });
          getAllUser();

          setEstablecimientosRutas((prevEstablecimientos) =>
            prevEstablecimientos.filter(
              (establecimiento) =>
                establecimiento.ID !== SelectedIdEstablecimiento
            )
          );
          setToastConfig({
            ...toastConfig,
            type: "success",
            message: "¡Eliminacion Exitosamente!",
            isVisible: true,
          });
        } else {
        }
      })
      .catch((err) => {
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: err.message,
          isVisible: true,
        });
        setAsignacion(initialState);
        hidePopup();
        hideDeletePopup();
      });
  };

  const onHiding = () => {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  };

  const asignarRuta = () => {
    setdisabledRuta(true);

    // Mapeo de días a números
    const diasMapping = {
      lunes: 1,
      martes: 2,
      miercoles: 3,
      jueves: 4,
      viernes: 5,
      sabado: 6,
      domingo: 7,
    };

    // Transformar los datos
    const dataFinal = Asignacion.establecimientosFinal.map((x) => {
      const dias = Object.keys(diasMapping).filter((dia) => x[dia]);
      const establecimiento = {
        ...x,
        dias: dias.map((dia) => diasMapping[dia]),
      };

      // Eliminar propiedades de días
      Object.keys(diasMapping).forEach((dia) => delete establecimiento[dia]);

      return establecimiento;
    });

    // Llamada al backend
    DinamicQueries.getDataWithParameters(
      "AsignarDiasEstablecimientos",
      "rutasPlanilla/",
      { id: PlantillaSelected, establecimientos: dataFinal }
    )
      .then((data) => {
        if (data.status === 200) {
          setToastConfig({
            ...toastConfig,
            type: "success",
            message: "¡Ruta cargada exitosamente!",
            isVisible: true,
          });

          // Reconstruir propiedades de días
          const newData = dataFinal.map((x) => {
            const establecimiento = { ...x };
            Object.keys(diasMapping).forEach((dia) => {
              establecimiento[dia] = x.dias.includes(diasMapping[dia]);
            });
            return establecimiento;
          });

          setAsignacion({
            ...Asignacion,
            establecimientos: newData,
            establecimientosFinal: newData,
          });

          setTimeout(() => {
            setdisabledRuta(false);
          }, 1000);
        }
      })
      .catch((err) => {
        console.error("Error asignando ruta:", err);
        if (err.response) {
          console.error("Respuesta del backend:", err.response.data);
        }
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: "Ocurrió un error al asignar la ruta.",
          isVisible: true,
        });
        setdisabledRuta(false);
      });
  };

  const saveButtonOptions = {
    icon: "check",
    text: "Guardar Ruta",
    onClick: asignarRuta,
    disabled: disabledRuta,
  };

  const handleOptionChangeAsigando = (e) => {
    if (e.fullName === "selectedRowKeys") {
      setidsEstablecimientoAsiganed(e.value);
    }
  };

  const eliminarRegistros = (arrayObjetos, arrayStrings) => {
    return arrayObjetos.filter((objeto) => !arrayStrings.includes(objeto.ID));
  };

  const deleteEstablecimientosMultiples = () => {
    console.log("Ejecutando eliminación de establecimientos múltiples...");
    DinamicQueries.getDataWithParameters(
      "getDeleteMultipleAsignacionEstablecimientos",
      "rutasPlanilla/",
      { id: PlantillaSelected, idEstablecimientos: idsEstablecimientoAsiganed }
    )
      .then((data) => {
        if (data.status === 200) {
          console.log("Eliminación múltiple exitosa, actualizando estados...");

          setEstablecimientosRutas((prevEstablecimientos) => {
            const updated = prevEstablecimientos.filter(
              (establecimiento) =>
                !idsEstablecimientoAsiganed.includes(establecimiento.ID)
            );
            console.log("Estado actualizado:", updated); // Verificar contenido actualizado
            return updated;
          });

          // Actualizar también el estado de Asignacion
          setAsignacion((prevAsignacion) => {
            const updatedEstablecimientos =
              prevAsignacion.establecimientos.filter(
                (establecimiento) =>
                  !idsEstablecimientoAsiganed.includes(establecimiento.ID)
              );
            return {
              ...prevAsignacion,
              establecimientos: updatedEstablecimientos,
            };
          });

          hideDeletePopup();
          AsignarData({
            id: PlantillaSelected,
            nombre_plantilla: PlantillaSelectedName,
          });
          getAllUser();

          setToastConfig({
            ...toastConfig,
            type: "success",
            message: "¡Eliminación múltiple exitosa!",
            isVisible: true,
          });
        } else {
          console.error("Error en la eliminación múltiple");
          setToastConfig({
            ...toastConfig,
            type: "error",
            message:
              "Error al eliminar los establecimientos. Inténtalo de nuevo.",
            isVisible: true,
          });
        }
      })
      .catch((err) => {
        console.error("Error al eliminar múltiples establecimientos:", err);
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: `Error: ${err.message}`,
          isVisible: true,
        });
        setAsignacion(initialState);
        hidePopup();
        hideDeletePopup();
      });
  };

  const getSelected = ({ selectedRowsData }) => {
    if (selectedRowsData.length > 0) {
      setWeekButtons(true);
      setSelectedStablisments(selectedRowsData);
    } else {
      setWeekButtons(false);
      setSelectedStablisments([]);
    }
  };

  const handleRowUpdated = async (e) => {
    try {
      const { data, key } = e;

      // Preparar objeto de actualización con los campos que cambiaron
      const updateData = { id: key };
      const localUpdate = {};

      if (data.nombre_plantilla !== undefined) {
        updateData.nombre_plantilla = data.nombre_plantilla.toUpperCase();
        localUpdate.nombre_plantilla = data.nombre_plantilla.toUpperCase();
      }

      if (data.orden_ruta !== undefined) {
        // Parsear a número y convertir a string para guardar
        const numericValue =
          data.orden_ruta === "" || data.orden_ruta === null
            ? ""
            : parseFloat(data.orden_ruta) || "";
        const stringValue = numericValue === "" ? "" : String(numericValue);
        updateData.orden_ruta = stringValue;
        localUpdate.orden_ruta = stringValue;
      }

      // Solo actualizar si hay cambios
      if (Object.keys(updateData).length > 1) {
        await DinamicQueries.getDataWithParameters(
          "actualizarNombrePlantilla",
          "rutasPlanilla/",
          updateData
        );

        // Actualizar el estado local
        setRutas((prevRutas) =>
          prevRutas.map((ruta) =>
            ruta.id === key ? { ...ruta, ...localUpdate } : ruta
          )
        );

        setToastConfig({
          ...toastConfig,
          type: "success",
          message: "¡Plantilla actualizada exitosamente!",
          isVisible: true,
        });
      }
    } catch (error) {
      console.error("Error al actualizar plantilla:", error);
      setToastConfig({
        ...toastConfig,
        type: "error",
        message: "Error al actualizar la plantilla.",
        isVisible: true,
      });
    }
  };

  const setToDay = (day) => {
    selectedStablisments.forEach((cadaEstablecimiento) => {
      const e = {
        value: true,
      };

      const data = {
        data: {
          key: cadaEstablecimiento.key,
        },
        columnIndex: day,
      };

      changeDays(e, data);
    });
  };

  const establecimientosPlantilla = useMemo(() => {
    const promotorSeleccionado = usuarios.find(
      (u) =>
        u.promotor === nuevaPlantilla.promotor &&
        u.region?.includes(nuevaPlantilla.region) &&
        u.cliente?.includes(nuevaPlantilla.cliente)
    );

    return promotorSeleccionado?.establecimientos || [];
  }, [
    usuarios,
    nuevaPlantilla.promotor,
    nuevaPlantilla.region,
    nuevaPlantilla.cliente,
  ]);

  // Filtrar rutas por región cuando se presiona el botón "Filtrar"
  const handleFiltrarRutasPorRegion = () => {
    if (!regionFiltro) {
      // Si no hay región seleccionada, no mostramos ninguna ruta
      setRutasFiltradas([]);
      return;
    }

    const filtradas = Rutas.filter(
      (ruta) => ruta.region && ruta.region === regionFiltro
    );
    setRutasFiltradas(filtradas);
  };

  const handleCrearPlantilla = () => {
    // Aquí puedes agregar la lógica para guardar la plantilla
    // Por ejemplo, llamar a un endpoint y luego cerrar el modal
    DinamicQueries.getDataWithParameters(
      "crearPlantilla",
      "rutasPlanilla/",
      nuevaPlantilla
    ).then((res) => {
      setShowCrearPlantilla(false);
      setNuevaPlantilla({ nombre_plantilla: "", region: "", orden_ruta: "" });
      // Recargar las rutas
      DinamicQueries.getData("getrutasPlanilla", "rutasPlanilla/").then(
        (res) => {
          setRutas(res.data);
        }
      );
      setToastConfig({
        ...toastConfig,
        type: "success",
        message: "¡Plantilla creada exitosamente!",
        isVisible: true,
      });
    });
  };
  const handleCrearPlantillaConEstablecimientos = () => {
    // Crear objeto a guardar
    const plantillaParaGuardar = {
      nombre_plantilla: nuevaPlantilla.nombre_plantilla,
      region: nuevaPlantilla.region,
      establecimientos: establecimientosSeleccionados, // array completo
    };

    // Guardar en Firestore o backend
    DinamicQueries.getDataWithParameters(
      "crearPlantilla",
      "rutasPlanilla/",
      plantillaParaGuardar
    ).then((res) => {
      setShowCrearPlantilla1(false);
      setNuevaPlantilla({
        nombre_plantilla: "",
        region: "",
        cliente: "",
        promotor: "",
        orden_ruta: "",
      });
      setEstablecimientosSeleccionados([]);

      // Recargar plantillas si es necesario
      DinamicQueries.getData("getrutasPlanilla", "rutasPlanilla/").then(
        (res) => {
          setRutas(res.data);
        }
      );

      setToastConfig({
        ...toastConfig,
        type: "success",
        message: "¡Plantilla creada exitosamente!",
        isVisible: true,
      });
    });
  };

  return (
    <React.Fragment>
      <div className="d-flex mt-4 mb-4 align-items-center justify-content-between">
        <div className="header-grid-title">
          <h5 className="content-block titleCliente">Plantilla Rutas</h5>
        </div>

        <div className="d-flex" style={{ gap: 8 }}>
          <SelectBox
            dataSource={Regiones}
            valueExpr="nombre_region"
            displayExpr="nombre_region"
            value={regionFiltro}
            onValueChanged={(e) => setRegionFiltro(e.value)}
            searchEnabled={true}
            placeholder="Seleccione una región"
            style={{ minWidth: 220 }}
          />

          <Button
            className="btn btn-primary"
            onClick={handleFiltrarRutasPorRegion}
            style={{ height: "40px" }}
          >
            Filtrar
          </Button>

          <Button
            className="btn btn-primary"
            onClick={() => {
              setNuevaPlantilla({
                nombre_plantilla: "",
                region: "",
                orden_ruta: "",
              });
              setShowCrearPlantilla(true);
            }}
            style={{ height: "40px" }}
          >
            Crear
          </Button>
          <Button
            className="btn btn-primary"
            onClick={() => {
              setNuevaPlantilla({
                nombre_plantilla: "",
                region: "",
                cliente: "",
                promotor: "",
                orden_ruta: "",
              });
              setEstablecimientosSeleccionados([]);
              setShowCrearPlantilla1(true);
            }}
            style={{ height: "40px" }}
          >
            Usar
          </Button>
        </div>
      </div>

      {/* Modal para crear plantilla */}
      <Popup
        visible={showCrearPlantilla}
        onHiding={() => {
          setShowCrearPlantilla(false);
          setNuevaPlantilla({
            nombre_plantilla: "",
            region: "",
            orden_ruta: "",
          });
        }}
        showTitle={true}
        title="Crear Nueva Plantilla"
        showCloseButton={true}
        width={400}
        height={350}
      >
        <div className="form-group">
          <label>Nombre de la plantilla</label>
          <input
            type="text"
            className="form-control"
            value={nuevaPlantilla.nombre_plantilla}
            onChange={(e) =>
              setNuevaPlantilla({
                ...nuevaPlantilla,
                nombre_plantilla: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group mt-3">
          <label>Orden Ruta</label>
          <input
            type="number"
            className="form-control"
            value={nuevaPlantilla.orden_ruta}
            onChange={(e) => {
              const value = e.target.value;
              // Parsear a número y convertir a string
              const numericValue = value === "" ? "" : parseFloat(value) || "";
              setNuevaPlantilla({
                ...nuevaPlantilla,
                orden_ruta: numericValue === "" ? "" : String(numericValue),
              });
            }}
          />
        </div>
        <div className="form-group mt-3">
          <label>Región</label>
          <SelectBox
            dataSource={Regiones}
            valueExpr="nombre_region"
            displayExpr="nombre_region"
            value={nuevaPlantilla.region}
            onValueChanged={(e) =>
              setNuevaPlantilla({ ...nuevaPlantilla, region: e.value })
            }
            searchEnabled={true}
          />
        </div>
        <div className="d-flex justify-content-end mt-4">
          <Button
            className="btn btn-primary"
            onClick={handleCrearPlantilla}
            disabled={
              !nuevaPlantilla.nombre_plantilla || !nuevaPlantilla.region
            }
          >
            Guardar
          </Button>
        </div>
      </Popup>
      <Popup
        visible={showCrearPlantilla1}
        onHiding={() => {
          setShowCrearPlantilla1(false);
          setNuevaPlantilla({
            nombre_plantilla: "",
            region: "",
            cliente: "",
            promotor: "",
            orden_ruta: "",
          });
          setEstablecimientosSeleccionados([]);
        }}
        showTitle={true}
        showCloseButton={true}
        fullScreen={true}
      >
        <div className="row">
          <div className="form-group col-md-6">
            <label>Nombre de la plantilla</label>
            <input
              type="text"
              className="form-control"
              value={nuevaPlantilla.nombre_plantilla}
              onChange={(e) =>
                setNuevaPlantilla({
                  ...nuevaPlantilla,
                  nombre_plantilla: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group col-md-6">
            <label>Región</label>
            <SelectBox
              dataSource={Regiones}
              valueExpr="nombre_region"
              displayExpr="nombre_region"
              value={nuevaPlantilla.region}
              onValueChanged={(e) => {
                console.log("region seleccionado:", e.value);
                setNuevaPlantilla({ ...nuevaPlantilla, region: e.value });
              }}
              searchEnabled={true}
            />
          </div>

          <div className="form-group col-md-6 mt-3">
            <label>Clientes</label>
            <SelectBox
              dataSource={clientesRegion}
              valueExpr="nombre_cliente"
              displayExpr="nombre_cliente"
              value={nuevaPlantilla.cliente}
              onValueChanged={(e) => {
                console.log("Cliente seleccionado:", e.value);
                setNuevaPlantilla({ ...nuevaPlantilla, cliente: e.value });
              }}
              searchEnabled={true}
            />
          </div>

          <div className="form-group col-md-6 mt-3">
            <label>Promotor</label>
            <SelectBox
              dataSource={promotoresFiltrados1}
              valueExpr="promotor"
              displayExpr="promotor"
              value={nuevaPlantilla.promotor}
              onValueChanged={(e) =>
                setNuevaPlantilla({ ...nuevaPlantilla, promotor: e.value })
              }
              searchEnabled={true}
              placeholder={
                promotoresFiltrados1.length === 0
                  ? "No hay promotores disponibles"
                  : "Seleccione un promotor"
              }
            />
            {promotoresFiltrados1.length === 0 &&
              nuevaPlantilla.region &&
              nuevaPlantilla.cliente && (
                <div style={{ color: "#b94a48", marginTop: 5, fontSize: 13 }}>
                  No hay promotores disponibles para la región y cliente
                  seleccionados.
                </div>
              )}
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <Button
            className="btn btn-primary"
            onClick={handleCrearPlantillaConEstablecimientos}
            disabled={
              !nuevaPlantilla.nombre_plantilla ||
              !nuevaPlantilla.region ||
              establecimientosSeleccionados.length === 0
            }
          >
            Guardar
          </Button>
        </div>

        <div className="mt-3">
          <DataGrid
            dataSource={establecimientosPlantilla}
            showBorders={true}
            style={{ height: "200px", width: "100%" }}
            keyExpr="ID"
            onSelectionChanged={(e) =>
              setEstablecimientosSeleccionados(e.selectedRowsData)
            }
          >
            <FilterRow visible={true} />
            <Selection mode="multiple" />
            <Column caption="ID" dataField="ID" dataType="string" width={100} />
            <Column
              caption="Nombre"
              dataField="nombre_establecimiento"
              dataType="string"
            />
            <Column
              caption="Región"
              dataField="nombre_region"
              dataType="string"
            />
          </DataGrid>
        </div>
      </Popup>

      <div className="tabla-Cliente">
        <DataGrid
          className="tabla-Cliente"
          dataSource={rutasFiltradas}
          showBorders={true}
          remoteOperations={true}
          focusedRowEnabled={true}
          defaultFocusedRowIndex={0}
          style={{ height: "400px", width: "100%" }}
          keyExpr="id"
          onRowUpdated={handleRowUpdated}
        >
          <Editing
            mode="row"
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={false}
          />
          <Export enabled={true} />
          <ColumnChooser enabled={true} mode="select" />
          <FilterRow visible={true} />
          <Paging defaultPageSize={12} />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
          />
          <HeaderFilter visible={true} />
          <Column
            // width={150}
            caption="Nombre"
            dataField="nombre_plantilla"
            dataType="string"
            allowEditing={true}
          />
          <Column
            // width={150}
            caption="Region"
            dataField="region"
            dataType="string"
            allowEditing={false}
          />
          <Column
            caption="Orden Ruta"
            dataField="orden_ruta"
            dataType="number"
            allowEditing={true}
          />
          <Column
            // width={80}
            caption=""
            allowSorting={false}
            cellRender={cellRender}
          />
        </DataGrid>
      </div>

      <Popup
        visible={showPopup}
        onHiding={hidePopup}
        showTitle={true}
        title={msgPopup}
        showCloseButton={true}
        fullScreen={true}
      >
        <ScrollView width={"100%"} height={"100%"}>
          <div className="row">
            <div className="col-md-5 d-flex justify-content-start">
              <SelectBox
                className="SelectBoxR mb-2 shadow"
                placeholder="Seleccione una región"
                label="Región"
                dataSource={Regiones}
                valueExpr="nombre_region"
                displayExpr="nombre_region"
                value={
                  PlantillaSelected
                    ? Rutas.find((r) => r.id === PlantillaSelected)?.region
                    : ""
                }
                disabled={false}
                searchEnabled={true}
              />
            </div>
          </div>

          <div
            className="row mx-5"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="col-md-5 mt-2">
              <div
                className={"dx-card"}
                style={{ padding: "20px", borderRadius: "15px" }}
              >
                <h6 className="title">Establecimientos</h6>
                <>
                  <DataGrid
                    className="tabla-user"
                    dataSource={EstablecimientosFiltrados}
                    showBorders={true}
                    remoteOperations={false}
                    // focusedRowEnabled={true}
                    defaultFocusedRowIndex={0}
                    style={{ height: "60vh", width: "100%" }}
                    keyExpr="ID_FB"
                    onOptionChanged={(e) => handleOptionChange(e)}
                    wordWrapEnabled={true}
                    loading={loadingEstablecimientos}
                  >
                    <FilterRow visible={true} />
                    <Selection mode="multiple" />
                    <LoadPanel enabled />
                    <Paging defaultPageSize={12} />
                    <Pager
                      showPageSizeSelector={true}
                      allowedPageSizes={allowedPageSizes}
                    />
                    <HeaderFilter visible={true} />

                    <Column caption={"ID"} dataField={"ID_STORE"} width={100} />
                    {/* <Column caption={"Id Origen"} dataField={"id_origen"} width={120} /> */}
                    <Column
                      dataField={"NAME"}
                      caption={"Nombre Establecimiento"}
                      dataType="string"
                    />
                  </DataGrid>
                </>
              </div>
            </div>
            <div
              className="col-md-1 mt-6"
              style={{
                display: "grid",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <Button
                className="btn btn-light mt-4"
                onClick={() => saveEstablishment()}
                style={{ width: "10vw" }}
              >
                Asignar <ArrowRight style={{ marginLeft: "5px" }} />
              </Button>
              <Button
                className="btn btn-light mt-4"
                onClick={(e) => deleteEstablecimientosMultiples()}
              >
                Eliminar <ArrowLeft style={{ marginLeft: "5px" }} />
              </Button>
              {/* onClick={() => saveUser()} */}
            </div>
            <div className="col-md-5 mt-2">
              <div
                className={"dx-card"}
                style={{ padding: "20px", borderRadius: "15px" }}
              >
                <h6 className="title">
                  Establecimientos asignados a {PlantillaSelectedName}
                </h6>
                {/* {AssingTo} */}
                <DataGrid
                  className="tabla-user"
                  dataSource={EstablecimientosRutas} // Vinculado al estado
                  showBorders={true}
                  remoteOperations={true}
                  defaultFocusedRowIndex={0}
                  style={{ height: "60vh", width: "100%" }}
                  key="Id"
                  wordWrapEnabled={true}
                  onOptionChanged={(e) => handleOptionChangeAsigando(e)}
                >
                  <FilterRow visible={true} />
                  <Selection mode="multiple" />
                  <LoadPanel enabled />
                  <Paging defaultPageSize={12} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                  />
                  <HeaderFilter visible={true} />

                  <Column
                    caption="ID"
                    dataField="ID"
                    dataType="string"
                    width={100}
                  />
                  <Column
                    caption="Nombre"
                    dataField="nombre_establecimiento"
                    dataType="string"
                  />
                  <Column
                    caption=""
                    allowSorting={false}
                    cellRender={cellRenderAsignar}
                  />
                </DataGrid>
              </div>
            </div>
          </div>
        </ScrollView>
      </Popup>

      <Popup
        width={"auto"}
        height={"auto"}
        visible={showPopupDelete}
        onHiding={hideDeletePopup}
        showTitle={true}
        title="Eliminar Asignacion"
        showCloseButton={true}
      >
        <ScrollView width="100%" height="100%">
          <div className="form-container text-center">
            <ExclamationDiamond className="warning_icon" />
            <h5>¿Seguro que desea eliminar esta asignación?</h5>
            <p>Esta acción no puede revertirse</p>
            <div className="d-flex text-center col-md-12 button_popup">
              <Button
                onClick={deleteEstablecimientos}
                className="btn btn-outline-primary"
              >
                Sí, eliminar
              </Button>
              <Button
                onClick={hideDeletePopup}
                className="btn btn-outline-secondary"
              >
                Cancelar
              </Button>
            </div>
          </div>
        </ScrollView>
      </Popup>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={toastConfig.displayTime}
      />
      <Popup
        visible={showPopupRuta}
        onHiding={hidePopupRuta}
        showTitle={true}
        title="Asignar Dias de Ruta"
        showCloseButton={true}
        fullScreen={true}
      >
        <ToolbarItem
          widget="dxButton"
          toolbar="top"
          location="after"
          options={saveButtonOptions}
        />
        <div className="row" style={{ height: "100%" }}>
          <div className="col-md-12 mt-2" style={{ height: "100%" }}>
            {weekButtons && (
              <>
                <div className="mb-3">
                  Asignar todos los establecimientos seleccionados para el dia:
                </div>
                <div className="mb-4">
                  <Button
                    onClick={() => {
                      setToDay(3);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Lunes
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(4);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Martes
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(5);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Miércoles
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(6);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Jueves
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(7);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Viernes
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(8);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Sábado
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(9);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px" }}
                  >
                    Domingo
                  </Button>
                </div>
              </>
            )}
            {/* {AssingTo} */}
            <DataGrid
              className="tabla-user"
              dataSource={Asignacion.establecimientos}
              showBorders={true}
              remoteOperations={true}
              // focusedRowEnabled={true}
              defaultFocusedRowIndex={0}
              style={{ height: "85vh", width: "100%" }}
              // ref={(ref) => { setDataGrid(ref.instance.clear) }}
              onSelectionChanged={getSelected}
              keyExpr="ID"
              wordWrapEnabled={true}
              paginate={false}
              paging={false}
              columnAutoWidth={true}
            >
              <Selection
                showCheckBoxesMode={"always"}
                selectAllMode={"allPages"}
                mode={"multiple"}
              />
              <FilterRow visible={true} />
              <LoadPanel enabled />
              <Scrolling
                useNative={false}
                scrollByContent={true}
                scrollByThumb={true}
                showScrollbar="onHover"
              />
              <HeaderFilter visible={true} />

              <Column
                caption="ID establecimiento"
                dataField="ID"
                dataType="string"
                width={220}
              />
              <Column
                caption="Nombre"
                dataField="nombre_establecimiento"
                dataType="string"
                width={290}
              />

              <Column
                caption="Lunes"
                dataField="lunes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Martes"
                dataField="martes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Miercoles"
                dataField="miercoles"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Jueves"
                dataField="jueves"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Viernes"
                dataField="viernes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Sabado"
                dataField="sabado"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Domingo"
                dataField="domingo"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
            </DataGrid>
          </div>
        </div>
      </Popup>
    </React.Fragment>
  );
}

export default PlantillaRutas;
